export default {"src":"/_next/static/media/cat-basic.ba5ecdc2.svg","height":48,"width":48};